



























































































































import { defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import sl from '@/serviceLocator';
import { EnvironmentInfo } from '@oare/types';
import IndividualCacheClearDialog from './components/IndividualCacheClearDialog.vue';

export default defineComponent({
  components: {
    IndividualCacheClearDialog,
  },
  setup() {
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const loading = ref(false);

    const cacheStatus = ref(false);
    const environmentInfo = ref<EnvironmentInfo>();

    onMounted(async () => {
      try {
        loading.value = true;
        cacheStatus.value = await server.getCacheStatus();
        environmentInfo.value = await server.getEnvironmentInfo();
        getLocale();
      } catch (err) {
        actions.showErrorSnackbar(
          'Error loading admin setting information. Please try again.',
          err as Error
        );
      } finally {
        loading.value = false;
      }
    });

    const updateCacheStatus = async (enable: boolean) => {
      try {
        if (enable) {
          await server.enableCache();
          actions.showSnackbar('Cache successfully enabled.');
        } else {
          await server.disableCache();
          actions.showSnackbar('Cache successfully disabled.');
        }
      } catch (err) {
        actions.showErrorSnackbar(
          'Error updating cache status. Please try again',
          err as Error
        );
      }
    };

    const flushCacheDialog = ref(false);
    const flushCache = async () => {
      try {
        await server.flushCache();
        actions.showSnackbar('Cache flushed successfully');
      } catch (err) {
        actions.showErrorSnackbar(
          'Error flushing cache. Please try again.',
          err as Error
        );
      } finally {
        flushCacheDialog.value = false;
      }
    };

    const individualClearDialog = ref(false);
    const individualClearDialogKey = ref(false);

    watch(individualClearDialog, () => {
      if (individualClearDialog.value) {
        individualClearDialogKey.value = !individualClearDialogKey.value;
      }
    });

    const currentLocale = ref('');
    const getLocale = () => {
      const storedLocale = localStorage.getItem('locale');
      if (storedLocale) {
        if (storedLocale === 'en') {
          currentLocale.value = 'English';
        } else if (storedLocale === 'tr') {
          currentLocale.value = 'Türkçe';
        } else {
          currentLocale.value = 'Unknown Preference Set. Please clear.';
        }
      } else if (navigator.language.includes('tr')) {
        currentLocale.value =
          'Not Set - Defaulting to Türkçe based on browser language settings';
      } else {
        currentLocale.value = 'Not Set - Defaulting to English';
      }
    };
    const clearLocalization = () => {
      localStorage.removeItem('locale');
      getLocale();
      actions.showSnackbar('Localization cleared successfully.');
    };

    return {
      loading,
      cacheStatus,
      updateCacheStatus,
      environmentInfo,
      flushCache,
      flushCacheDialog,
      individualClearDialog,
      individualClearDialogKey,
      clearLocalization,
      getLocale,
      currentLocale,
    };
  },
});
